import React from "react";
import { AppBar, Container, CssBaseline, Toolbar } from "@mui/material";
import Logo from "./Logo";

const Layout = ({ children }) => (
  <>
    <CssBaseline />
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        <Logo />
      </Toolbar>
    </AppBar>
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      {children}
    </Container>
  </>
);

export default Layout;
